/**
 * Reveal on scroll animation
 * Adds 'visible' class to elements with 'reveal' class when they enter viewport
 */
document.addEventListener('DOMContentLoaded', function() {
    // Reveal on scroll
    const reveals = document.querySelectorAll('.reveal');
    
    if (reveals.length > 0) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry, i) => {
                if (entry.isIntersecting) {
                    setTimeout(() => entry.target.classList.add('visible'), i * 80);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.12
        });
        
        reveals.forEach(el => observer.observe(el));
    }
    
    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
});